import "../scss/main.scss";
import "core-js/stable";

import { VwFix } from "./vwFix";
import { InternalLinks } from "./internalLinks";
import { MainNavigation } from "./mainNavigation";
import { PageHeader } from "./pageHeader";

(function () {
	new VwFix();
	new InternalLinks();

	if (document.querySelector(".page-header")) {
		new MainNavigation({
			el: ".page-header",
			navigationContainer: ".page-header__mobile-navigation",
			navigationActiveClass: "page-header__mobile-navigation--active",
			toggleContainer: ".mobile-navigation-toggle",
			toggleActiveClass: "mobile-navigation-toggle--active",
			toggleButton: ".mobile-navigation-toggle__button",
		});
	}

	if (document.querySelector(".page-header")) {
		new PageHeader({
			el: ".page-header",
			scrollClass: "page-header--scroll",
		});
	}
})();
